module.exports = __webpack_public_path__ + "img/ic-survey.02468c22.png";